<template>
  <div id="app">
    <mask-dialog :showMask="token === null" url="index"></mask-dialog>
    <img :src="banner" style="width:100%" class="margin-bottom-16" />
    <div class="container white-back">
      <div class="text-center font-18">quota(₹)</div>
      <div class="text-center font-18 font-weight-bold margin-top-14 margin-bottom-23 font-44">{{ amount }}.00</div>

      <div v-if="!userRepayInfo">
        <div class="flex flex-align-center flex-justify-between">
          <van-icon name="https://imgs.hdjfg.com/gift/img/home_reduce.png" size="32" @click="reduce" />
          <div class="progress-bar-box relative margin-left-8  margin-right-8" style="width: 100%;">
            <div class="absolute progress-bar-content" :style="'width: ' + this.amount / 2000 + '%'">
            </div>
          </div>
          <van-icon name="https://imgs.hdjfg.com/gift/img/home_add.png" size="32" @click="add" />
        </div>
        <div class="flex flex-align-center flex-justify-between margin-top-42">
          <div :class="days === 7 ? 'common-day active' : 'common-day'" @click="days = 7"> 7day</div>
          <div :class="days === 14 ? 'common-day active' : 'common-day'" @click="days = 14">14day</div>
          <div :class="days === 21 ? 'common-day active' : 'common-day'" @click="days = 21"> 21day</div>
        </div>
        <div class="flex flex-align-center flex-justify-center  margin-top-14 margin-bottom-34">
          <div :class="days === 30 ? 'common-day active margin-right-12' : 'common-day margin-right-12'"
            @click="days = 30">
            30day</div>
          <div :class="days === 60 ? 'common-day active' : 'common-day'" @click="days = 60">60day</div>
        </div>
      </div>

      <div class="text-center" style="height: 44px;">
        <span v-if="userRepayInfo" class="theme-back apply " @click="repay">REPAY NOW</span>
        <span v-else class="theme-back apply " @click="apply">GO APPLY</span>
      </div>
    </div>
  </div>
</template>

<script>
import MaskDialog from './Common/MaskDialog.vue'
export default {
  components: {
    MaskDialog,
  },
  data() {
    return {
      token: null,
      days: 7,
      amount: 150000,
      userRepayInfo: null,
      banner: ''
    }
  },
  computed: {

  },
  created() {
    this.token = window.localStorage.getItem('token')
    this.getBanner()
    if (this.token) {
      this.getUserRepayInfo()
    }
    let od = window.location.href.split("?")[1];
    if(od){
      let parameters = this.parameter(od);
      if(parameters.channel){
        window.localStorage.setItem('channel', parameters.channel)
      }
    }
  },
  methods: {
    parameter(data) {
      let arr = data.split("&")
      console.log(arr)
      let argument = {};
      for (var i = 0; i < arr.length; i++) {
        argument[arr[i].split("=")[0]] = arr[i].split("=")[1]
      }
      return argument
    },
    apply() {
      this.$router.push({
        name: 'cash'
      })
    },
    repay() {
      this.$router.push({
        name: 'repayment'
      })
    },
    reduce() {
      if (this.amount > 10000) this.amount -= 10000
    },
    add() {
      if (this.amount < 200000) this.amount += 10000
    },
    async getBanner() {
      const { data: res } = await this.$http.post('/api/sys/banner', { type: 2 })
      if (res.code === 0) {
        this.banner = res.data.img
      } else {
        this.$toast(res.msg)
      }
    },
    isObjectEmpty(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    async getUserRepayInfo() {
      const { data: res } = await this.$http.post('/api/product/userRepayInfo')
      if (res.code === 0) {
        this.userRepayInfo = this.isObjectEmpty(res.data) ? null : res.data
        this.amount = res.data.all_amount || 150000
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #FFA775;
  min-height: 100vh;
  padding: 43px 18px 0px 18px;
  box-sizing: border-box;

  .container {
    padding: 18px 16px 21px 16px;
    border-radius: 14px;
    text-align: center;
    box-sizing: border-box;

    .progress-bar-box {
      height: 12px;
      background: #FFF2EB;
      border-radius: 7px;

      .progress-bar-content {
        background: #FF5D00;
        border-radius: 7px;
        height: 12px;
      }
    }

    .common-day {
      padding: 10px 25px;
      font-size: 16px;
      line-height: 18px;
      height: 18px;
      background: #F6F6F6;
      border-radius: 19px;
    }

    .active {
      color: #FFFFFF;
      background: #FF5D00;
    }

    .apply {
      padding: 12px 58px;
      border-radius: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      font-family: HelveticaNeue-Bold, HelveticaNeue;
      width: 87px;


    }
  }

}
</style>
